<template>
  <div id="dirManagement">
    <div class="background-white first-title" >
      <span class="title">目录管理</span>
        <!-- <el-select v-if="branchtypeLst.length>0"  v-model="branchtype" placeholder="请选择渠道" style="width:30%;float:right" @change="changeBranchtype()">
          <el-option  v-for="(branchtype,index) in branchtypeLst" :key="index" :label="branchtype.name" :value="branchtype.code"></el-option>
        </el-select> -->
    </div>
    <div class="item">
        <div class="item-title"  style="padding-right: 0;">目录结构
           <el-button type="primary" @click="editDirShow(1)" class="search-btn">新增目录</el-button>
        </div>
    </div>
    <!-- 左侧菜单start -->
    <div class="dir-menu background-white"    :style="treeDivHeight">

      <el-tree
          :data="menuDirTree"
          :props="menuTreeProps"
          @node-click="changeTreeDir"
          @node-expand="expandNode"
          @node-collapse="closeNode"
          :default-expanded-keys="defaultExpandLst"
          ref="dirTree"
          node-key="dirCode"
          :expand-on-click-node="false">
          <span class="custom-tree-node" slot-scope="{ node, data }">
            <span>
              <img src="../../../assets/train/dir.png" style="height:14px"/>
              {{ node.label }}</span>

          </span>
        </el-tree>
    </div>
    <!-- 左侧菜单 end-->
    <!-- 右侧显示start -->
    <div class=" dir-content ">
      <div class="background-white ">
          <div class="title-now">
              <img src="../../../assets/train/dir.png"/>
          </div>
          <div style="float:left;margin-top: 3px;margin-left: 1%;">
              <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item  v-for="(breadcrumb,index) in breadcrumbLst" :key="index" ><a  href="jacascript::void(0)" @click="changeTreeDir(breadcrumb)">{{breadcrumb.dirName}}</a></el-breadcrumb-item>
              </el-breadcrumb>
          </div>
          <div style="clear:both"></div>
      </div>

        <div class="background-white item overflow"  :style="tableDivHeight">
          <div v-if="tableData.length==0" class="none-data">
            <img  src="../../../assets/train/none.png"/>
            <div>暂时没有更多目录啦</div>
          </div>
              <el-table
              v-else
                :data="tableData"
                style="width: 100%">
                <el-table-column
                  prop="dirName"
                  label="目录名"
                  align="center"
                  >
                  <template slot-scope="scope">
                    <el-button type="text"    size="small"  @click="changeTreeDir(scope.row)" >
                     <img src="../../../assets/train/dir.png" style="height:14px"/> {{scope.row.dirName}}</el-button>
                  </template>
                </el-table-column>
                <el-table-column
                  prop="modifyUser"
                  label="操作员"
                    align="center"
                  >
                </el-table-column>
                <el-table-column
                  prop="address"
                  label="操作时间"
                  :formatter=timeFormer
                    align="center"
                  >
                </el-table-column>
                <el-table-column
                  prop="address"
                  label="操作"
                  width="250"
                    align="center"
                  >

                  <template slot-scope="scope">

                      <el-button type="text"    size="small"  @click="setAuth(scope.row.dirCode)" >设置权限</el-button>
                      <el-button type="text"    size="small"  @click="removeDir(scope.row.dirCode)">删除</el-button>
                      <el-button type="text"  size="small"  @click="editDirShow(2,scope.row.dirCode)">重命名</el-button>
                      <el-button type="text"    size="small"  @click="editDirShow(3,scope.row.dirCode)">移动</el-button>
                  </template>
                  </el-table-column>
              </el-table>
      </div>
    </div>

    <!-- 表单弹出框start -->
    <el-dialog :title="editDialogTitle" :visible.sync="dialogFormVisible">
      <el-form   label-width="80px">
        <el-form-item  label="目录名称"   v-if="actionFlag==1||actionFlag==2">
          <el-input v-model="dirDTO.dirName" autocomplete="off" :class="{error:errors.has('dirName')}" name="dirName" v-validate="'required'" maxlength="20"></el-input>
        </el-form-item>
        <el-form-item label="所在位置"   v-if="actionFlag==1||actionFlag==3">
        <el-popover
            placement="bottom"
            v-model="selectLocationVisible"
            trigger="click"
            popper-class="dirManagement-pop-class">
            <div class="editorDialog-tree-div">
              <el-tree
              :data="dirLocationTree"
              :props="menuTreeProps"
              @node-click="setDirLocation"
              ref="dirLocation"
              node-key="dirCode"
              :highlight-current=true
              :expand-on-click-node="false">
              <span class="custom-tree-node" slot-scope="{ node, data }">
                <span> {{ node.label }}</span>
              </span>
              </el-tree>
            </div>
            <el-input v-model="dirLocation" autocomplete="off" slot="reference" :class="{error:errors.has('dirLocation')}" name="dirLocation" readonly="readonly" v-validate="'required'" ></el-input>
          </el-popover>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="saveDir()">确 定</el-button>
      </div>
    </el-dialog>
    <!-- 表单弹出框end -->
    <el-dialog title="设置权限" :visible.sync="authFormVisible" >
      <div class="person-auth">
        <!-- <el-radio v-model="radio" label="1" @change="radioChange()" :disabled="(selectedPartPerson+selectedPartCom)>0&&radio==2">人员权限</el-radio> -->
        <el-radio v-model="radio" label="1" @change="radioChange()"  >人员权限</el-radio>
        <div :class="{'disabled':radio!=1}">
          <el-row :gutter="20">
            <el-col :span="16">
              <div :class="{'addPerson-btn':true,'point-cursor':radio==1}" @click="selectPerson()" :disabled="radio!=1">
                  <i class="el-icon-plus"></i>添加成员
              </div>
            </el-col>

            <el-col :span="8" style="text-align:right" >

              <el-upload
                class="upload-demo"
                :action= "uploadUrl"
                :data="uploadData"
                ref="uploadAgent"
                :on-success="uploadSuccess"
                :on-error="uploadError"
                :headers="uploadHeader"
                :disabled="radio!='1'"
                >

                <el-button size="small" type="primary">导入</el-button>
              </el-upload>
            </el-col>
          </el-row>
        </div>
        <div class="select-person-div">
           <div class="person-round"  v-for="(authAgent,index) in authedAgentLst" :key="index">{{authAgent}}</div>
           <div :class="{'disabled':radio!=1,'search-more':true,'point-cursor':radio==1}"  v-if="authedAgentLst.length>0" @click="selectPerson()" :disabled="radio!=1">查看更多<i class="el-icon-arrow-right"></i></div>
           <div style="clear:both"></div>
        </div>
      </div>
      <div :class="{'disabled':radio!=2,'org-auth':true}">
        <el-radio v-model="radio" label="2" @change="radioChange()" >渠道&机构&职级权限</el-radio>
        <!-- <el-radio v-model="radio" label="2" @change="radioChange()"  :disabled="(selectedPartPerson+selectedPartCom)>0&&radio==1">机构&职级权限</el-radio> -->
         <el-row :gutter="20">

            <el-col :span="8">
              <div >
                  机构权限
              </div>
              <el-tree
                :data="managecomTree"
                :props="managecomTreeProps"
                ref="managecomTree"
                node-key="manageCom"
                 show-checkbox
                 >
              </el-tree>
            </el-col>

            <el-col :span="8" >
              <div >
                  渠道
              </div>
              <el-radio-group v-model="channelRadio">
                <el-radio class="channel-radio" :label="channel" v-for="(channel, index) in channels" :key="index" :disabled="radio!=2">{{channel}}</el-radio>
              </el-radio-group>
            </el-col>

            <el-col :span="8" >
              <div >
                  职级权限
              </div>
              <el-tree
                :data="agentCodeTree"
                :props="agentCodeTreeProps"
                node-key="code"
                ref = "agentCodeTree"
                show-checkbox="">
              </el-tree>
            </el-col>

          </el-row>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="authFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="saveAuth()">确 定</el-button>
      </div>
    </el-dialog>

    <el-dialog title="设置权限" :visible.sync="personFormVisible">
      <div >
          <el-transfer
            filterable
            :filter-method="filterMethod"
            :props="transferProp"
            filter-placeholder="搜索成员"
            v-model="authAgentLst"
            :data="allImprotAgentLst">
         </el-transfer>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="cancelPerson()">取 消</el-button>
        <el-button type="primary" @click="surePerson()">确 定</el-button>
      </div>
    </el-dialog>

  </div>
</template>

<script>
import api from '@/modules/api.js'
import date from '@/filters/date.js'
import localStorage from '@/components/cache/localStorage'
import sessionStorage from '@/components/cache'
import getIP from '@/components/utils/getIP'
export default {
  data () {
    return {
      // 剩余时间
      uploadUrl: process.env.UPLOAD_ROOT + '/file/v1/hasl/fileAdmin/fileAdmin/upload',
      dialogFormVisible: false,
      authFormVisible: false,
      selectLocationVisible: false,
      dialogTitle: '编辑课程',
      personFormVisible: false,
      allImprotAgentLst: [],
      radio: '1',
      channelRadio: '',
      channels: [],
      menuTreeProps: {
        children: 'childDir',
        label: 'dirName',
        id: 'dirCode'
      }, // 菜单树配置
      managecomTreeProps: {
        label: 'manageName',
        id: 'manageCom'
      },
      agentCodeTreeProps: {
        label: 'codeLabel',
        id: 'code'
      },
      transferProp: {
        key: 'agentCode',
        label: 'agentCode'
      },
      menuDirTree: [], // 菜单树
      dirLocationTree: [],
      branchtypeLst: [], // 渠道列表
      branchtype: '', // 请求渠道
      tableData: [], // 列表
      currentParentDir: {'dirCode': '', 'dirName': '全部'},
      breadcrumbLst: [{'dirCode': '', 'dirName': '全部'}],
      actionFlag: 1, // 操作 1-增加 2-改名 3-移动
      editDialogTitle: '',
      dirLocation: '', // 文件所在地显示
      dirDTO: {
        'dirCode': '',
        'dirName': '',
        'parentDircode': '',
        'branchtype': ''
      },
      uploadData: {
        'domain': 'TRAIN',
        'buz': 'FILE',
        'expired': 60,
        'actions': '',
        'buzId': '123',
        'auth': 1
      },
      uploadHeader: {
        'ComId': 'ebiz-agent',
        'Authorization': 'Basic ' + sessionStorage.session_get('token'),
        'Accept-Device': 'NULL',
        'Accept-DeviceOS': 'NULL',
        'Accept-Location': 'NULL',
        'Accept-ISP': 'NULL',
        'Accept-StartTime': 'NULL',
        'Accept-TimeZone': -(new Date().getTimezoneOffset() * 60000),
        'Accept-Attr1': getIP.getBrowserInfo(),
        'Accept-Attr2': 'PC',
        'Accept-Attr3': '',
        'Real-Ip': getIP.getBrowserInfo(),
        'Accept-Attr4': 'NULL',
        'Accept-Attr6': sessionStorage.session_get('username')
      },
      authDirCode: '', // 权限当前的dirCode
      authAgentLst: [], // 选中人员的集合，可取消
      authedAgentLst: [], // 选中人员的集合
      agentCodeTree: [], // 职级树
      managecomTree: [], // 机构
      defaultExpandLst: [],
      treeDivHeight: {
        height: ''
      },
      tableDivHeight: {
        height: ''
      }
      // selectedPartPerson: 0,
      // selectedPartCom: 0
    }
  },
  mounted () {
    this.height()
    this.getMenuDirTree()
    this.getBranchtypeLst()
  },
  methods: {
    height () {
      this.treeDivHeight.height = window.innerHeight - 240 + 'px'
      this.tableDivHeight.height = window.innerHeight - 294 + 'px'
    },
    expandNode (obj) {
      this.defaultExpandLst.push(obj.dirCode)
    },
    closeNode (obj) {
      let index = this.defaultExpandLst.indexOf(obj.dirCode)
      if (index >= 0) {
        this.defaultExpandLst.splice(index, 1)
      }
    },

    filterMethod (query, item) {
      return item.agentCode.indexOf(query) > -1
    },
    editDirShow (flag, dirCode) {
      let that = this
      that.actionFlag = flag
      that.dialogFormVisible = true
      that.errors.clear()
      that.dirDTO = {
        'dirCode': '',
        'dirName': '',
        'parentDircode': '',
        'branchtype': ''
      }
      that.dirLocation = ''
      if (flag === 1) {
        that.editDialogTitle = '新增目录'
      } else {
        api.getDirInfoByCode({'dirCode': dirCode}, function (res) {
          if (res.result.isSuccess === true) {
            that.dirDTO = res.data

            if (flag === 2) {
              that.editDialogTitle = '修改名称'
            } else {
              that.editDialogTitle = '移动目录'
              that.$refs.dirLocation.setCurrentKey(that.dirDTO.parentDircode)
              that.setDirLocation({'dirCode': that.dirDTO.parentDircode})
            }
          } else {
            that.$message.error(res.result.error)
          }
        })
      }
    },
    uploadSuccess (res) {
      let that = this
      if (res.result.isSuccess === true) {
        that.$refs.uploadAgent.clearFiles()
        // 上传完成，开始导入
        api.importDirAgent({'dirCode': that.authDirCode, 'filePath': api.urlDomin + res.data.fileId + '.' + res.data.ext}, function (res) {
          if (res.result.isSuccess === true) {
            // 获取全部代理人
            that.getAllAgent()
            that.$message({
              type: 'success',
              message: '文件导入成功'
            })
          } else {
            that.$message.error(res.result.error)
          }
        })
      } else {
        that.$message.error(res.result.error)
        that.$refs.uploadAgent.clearFiles()
        // this.fileList = []
        // this.loading = false
      }
    },
    uploadError () {
      this.$message.error('导入失败，请稍后重新操作')
    },
    /**
     * 获取目录树
     */
    getMenuDirTree () {
      let that = this
      api.getDirTree({}, function (res) {
        that.dirLocationTree = []
        that.menuDirTree = []
        if (res.result.isSuccess === true) {
          // that.menuDirTree = res.data

          let dirLocationTree = {'dirCode': '', 'dirName': '全部', 'childDir': []}
          dirLocationTree.childDir = res.data
          that.dirLocationTree.push(dirLocationTree)
          that.menuDirTree.push(dirLocationTree)
        } else {
          that.$message.error(res.result.error)
        }
      })
    },
    /**
     * 时间格式
     */
    timeFormer (row) {
      if (row.modifyDate != null) {
        // let date = new Date(row.modifyDate)
        return date.formatDate(row.modifyDate, 'yyyy.MM.dd hh:mm:ss')
      }
    },
    /**
     * 切换目录触发
     */
    changeTreeDir (data) {
      this.currentParentDir = data
      // 1.渲染面包屑
      this.breadcrumbLst = []
      let node = this.$refs.dirTree.getNode(data.dirCode)

      this.breadcrumbLst.push(
        {
          'dirCode': data.dirCode,
          'dirName': data.dirName
        }
      )
      while (node.level > 1) {
        this.breadcrumbLst.push(
          {
            'dirCode': node.parent.data.dirCode,
            'dirName': node.parent.data.dirName
          }
        )
        node = this.$refs.dirTree.getNode(node.parent.data.dirCode)
      }
      this.breadcrumbLst = this.breadcrumbLst.reverse()

      // 2.渲染表格
      this.getSubDirLst(data.dirCode)
    },
    /**
     * 选择所在位置
     */
    setDirLocation (data) {
      let dirLocationLst = []
      let node = this.$refs.dirLocation.getNode(data.dirCode)
      console.log(node)
      dirLocationLst.push(node.data.dirName)
      while (node.level > 1) {
        dirLocationLst.push(node.parent.data.dirName)
        node = this.$refs.dirLocation.getNode(node.parent.data.dirCode)
      }
      dirLocationLst = dirLocationLst.reverse()
      this.dirLocation = dirLocationLst.join('>')
      this.selectLocationVisible = false
      this.dirDTO.parentDircode = data.dirCode
      this.errors.remove('dirLocation')
    },
    saveDir () {
      let that = this
      that.$validator.validateAll().then((result) => {
        if (result) {
          that.dirDTO.branchtype = that.branchtype
          if (that.actionFlag === 1) {
            api.saveDir(that.dirDTO, function (res) {
              if (res.result.isSuccess === true) {
                that.dialogFormVisible = false
                that.$message.success('保存成功')
                // 重新渲染数据
                that.getMenuDirTree()
                that.getSubDirLst(that.currentParentDir.dirCode)
              } else {
                that.$message.error(res.result.error)
              }
            })
          } else {
            api.updateDir(that.dirDTO, function (res) {
              if (res.result.isSuccess === true) {
                that.dialogFormVisible = false
                that.$message.success('保存成功')
                // 重新渲染数据
                that.getMenuDirTree()
                that.getSubDirLst(that.currentParentDir.dirCode)
              } else {
                that.$message.error(res.result.error)
              }
            })
          }
        }
      })
    },
    getBranchtypeLst () {
      let that = this
      api.getBranchtypeLst({}, function (res) {
        if (res.result.isSuccess === true) {
          that.branchtypeLst = res.data
          if (res.data.length > 0) {
            that.branchtype = res.data[0].code
          }
          that.getSubDirLst('')
        } else {
          that.$message.error(res.result.error)
        }
      })
    },
    changeBranchtype () {
      this.getMenuDirTree()
      this.getSubDirLst('')
    },
    getSubDirLst (dirCode) {
      let that = this
      api.getSubDirLst({'branchtype': that.branchtype, 'dirCode': dirCode}, function (res) {
        if (res.result.isSuccess === true) {
          that.tableData = res.data
        } else {
          that.$message.error(res.result.error)
        }
      })
    },
    removeDir (dirCode) {
      let that = this
      this.$confirm('此操作将会删除此目录下的全部子目录与全部课程, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        api.delDir({'dirCode': dirCode}, function (res) {
          if (res.result.isSuccess === true) {
            that.dialogFormVisible = false
            that.$message.success('删除成功')
            // 重新渲染数据
            that.getMenuDirTree()
            that.getSubDirLst(that.currentParentDir.dirCode)
          } else {
            that.$message.error(res.result.error)
          }
        })
      })
    },
    setAuth (dirCode) {
      let that = this
      that.authDirCode = dirCode
      that.authAgentLst = []
      that.authedAgentLst = []
      that.radio = '1'
      // 渲染选中的权限
      api.getAuthAgent({'dirCode': dirCode}, function (res) {
        if (res.result.isSuccess === true) {
          for (var i = 0; i < res.data.length; i++) {
            that.authAgentLst.push(res.data[i].agentCode)
            that.authedAgentLst.push(res.data[i].agentCode)
          }
          that.selectedPartPerson = that.authedAgentLst.length
        } else {
          that.$message.error(res.result.error)
          that.selectedPartPerson = 0
        }
      })
      // 获取职级，机构全部权限
      api.getGradeMangecomTree({}, function (res) {
        if (res.result.isSuccess === true) {
          that.aa = res.data.agentCodeTree
          that.bb = res.data.managecomTree
          that.channels = res.data.allChannels
          // 在节点添加disabled,必须加，要不没法改变
          that.deepDisable(that.aa, true)
          that.deepDisable(that.bb, true)
          that.agentCodeTree = that.aa
          that.managecomTree = that.bb
        } else {
          that.$message.error(res.result.error)
        }
      })
      //  获取职级，机构选中权限
      api.getManageComAuthByDirCode({'dirCode': dirCode}, function (res) {
        if (res.result.isSuccess === true) {
          let managecomTree = []
          let agentGradeTree = []
          if (res.data != null && res.data.managecom != null && res.data.managecom !== '') {
            managecomTree = res.data.managecom.split(',')
          }
          if (res.data != null && res.data.agentGrade != null && res.data.agentGrade !== '') {
            agentGradeTree = res.data.agentGrade.split(',')
          }
          if (res.data != null && res.data.channel != null && res.data.channel !== '') {
            that.channelRadio = res.data.channel
          }
          // that.selectedPartCom = managecomTree.length + agentGradeTree.length
          that.$refs.agentCodeTree.setCheckedKeys(agentGradeTree)
          that.$refs.managecomTree.setCheckedKeys(managecomTree)
          // 获取职级，机构全部权限
          // api.getGradeMangecomTree({}, function (res) {
          //   if (res.result.isSuccess === true) {
          //     that.aa = res.data.agentCodeTree
          //     that.bb = res.data.managecomTree
          //     // 在节点添加disabled,必须加，要不没法改变
          //     if (that.selectedPartCom > 0) {
          //       that.radio = '2'
          //       that.agentCodeTree = that.aa
          //       that.managecomTree = that.bb
          //     } else {
          //       that.radio = '1'
          //       that.deepDisable(that.aa, true)
          //       that.deepDisable(that.bb, true)
          //       that.agentCodeTree = that.aa
          //       that.managecomTree = that.bb
          //     }
          //   } else {
          //     that.$message.error(res.result.error)
          //   }
          // })
        } else {
          that.$message.error(res.result.error)
        }
      })
      // 获取全部代理人
      that.getAllAgent()

      that.authFormVisible = true
    },
    selectPerson () {
      if (this.radio === '1') {
        this.personFormVisible = true
      }
    },
    getAllAgent () {
      let that = this
      // 获取全部导入的代理人
      that.allImprotAgentLst = []
      api.getAllAgent({'dirCode': that.authDirCode}, function (res) {
        if (res.result.isSuccess === true) {
          that.allImprotAgentLst = res.data
        } else {
          that.$message.error(res.result.error)
        }
      })
    },
    surePerson () {
      this.authedAgentLst = this.authAgentLst
      this.personFormVisible = false
    },
    cancelPerson () {
      this.authAgentLst = this.authedAgentLst
      this.personFormVisible = false
    },
    deepDisable (obj, flag) {
      var result = {}
      for (var key in obj) {
        var copy = obj[key]
        if (this.isClass(copy) === 'Object') {
          result[key] = this.deepDisable(copy, flag)
        } else if (this.isClass(copy) === 'Array') {
          result[key] = this.deepDisable(copy, flag)
        } else {
          obj.disabled = flag
        }
      }
      return result
    },
    isClass (o) {
      if (o === null) return 'Null'
      if (o === undefined) return 'Undefined'
      return Object.prototype.toString.call(o).slice(8, -1)
    },
    saveAuth () {
      let that = this
      let agentCodeTree = that.$refs.agentCodeTree.getCheckedKeys()
      let managecomTree = that.$refs.managecomTree.getCheckedKeys()
      // if ((agentCodeTree.length + managecomTree.length) > 0 && that.authedAgentLst.length > 0) {
      //   that.$message.error('人员，机构&职级权限二者只可选其一哦~~')
      //   return
      // }
      let managecom = managecomTree.join(',')
      let agentGrade = agentCodeTree.join(',')
      let req = {
        agentGrade: agentGrade,
        managecom: managecom,
        dirCode: that.authDirCode,
        agentAuthLst: that.authedAgentLst,
        channels: that.channelRadio
      }
      api.saveManageComAuth(req, function (res) {
        if (res.result.isSuccess === true) {
          that.$message.success('保存成功')
          that.authFormVisible = false
          that.getSubDirLst(that.currentParentDir.dirCode)
        } else {
          that.$message.error(res.result.error)
        }
      })
    },
    radioChange () {
      if (this.radio === '1') {
        this.deepDisable(this.managecomTree, true)
        this.deepDisable(this.agentCodeTree, true)

        // 将渠道机构职级的权限 置为空
        this.channelRadio = ''
      } else {
        this.deepDisable(this.agentCodeTree, false)
        this.deepDisable(this.managecomTree, false)
      }
    }
  },
  watch: {
    '$route': {
      deep: true,
      handler: function (newVal, oldVal) {
        if (newVal.name === 'dirManagement') {
          this.height()
          this.currentParentDir = {'dirCode': '', 'dirName': '全部'}
          this.breadcrumbLst = [{'dirCode': '', 'dirName': '全部'}]
          this.getMenuDirTree()
          this.getBranchtypeLst()
          this.defaultExpandLst = []
        }
      }
    }
  }

}
</script>
<style lang="scss" scoped>
 .channel-radio{
   display: block;
   margin-top: 10px;
 }
 .background-white{
   background-color: #fff;
   padding:10px 1%
 }
 .title{
   font-size:16px;
   font-weight:900
 }
 .item{
   margin-top: 10px;
 }
 .item-title{
  background-color: #eee;
        padding: 5px 2%;
    height: 40px;
    line-height: 40px;
 }
 .search-btn{
    float: right;
    margin-right: 1%;

 }
 .search-param{
    float: right;
    width: 30%;
 }
 .title-now{
   float: left;
  //  margin: 10px 1% 0 2%
 }
 .title-now img{
    height: 20px;
 }
.el-tree-node__content{
  margin-bottom: 10px
}
.dir-menu{
  width: 20%;
  margin-right: 1%;
  float: left;
  padding:10px 0;
  overflow: auto;
}
.dir-content{
  width: 79%;
  float: left;
}
.dir-menu-title{
    background-color: rgb(238, 238, 238);
    margin-top: 30px;
    padding: 10px 5%;
}
.person-auth{
    padding-bottom: 10px;
    border-bottom: solid 1px #eee;
    max-height: 200px;
    overflow-y: auto;
    overflow-x:hidden
}
.org-auth{
  height: 200px;
  overflow-y:auto ;
  overflow-x:hidden
}
.addPerson-btn{
  line-height: 40px
}
.el-radio__label{
  font-weight: 900
}
.el-radio{
  margin-bottom: 10px
}
.el-dialog__body{
  overflow-y: auto;
  height:300px;
}
.person-round{
background-color: #9e9fa0;
    color: #fff;
    padding: 5px 1px;
    height: 40px;
    width: 46px;
   text-align: center;
   border-radius: 50%;
   text-align: center;
   color: #fff;
   margin: 0 auto;
   border: solid 0.01rem #9E9FA0;
  float: left;
  word-break: break-all;
  margin: 1%;
  vertical-align: middle;
}
.search-more{
  width: 100px;
  float: left;
  line-height: 60px;
  margin-left: 1%
}
.select-person-div{
  margin: 10px 0
}
.first-title{
  padding: 10px 2%;
  height: 40px;
  line-height: 40px
}
// .editorDialog-tree-div{
// height: 200px;
//     overflow: auto;
// }

.disabled{
  color: #9e9fa09c
}
.disabled btn{
  background-color: #9e9fa09c
}
.point-cursor{
  cursor: pointer;
}

 .overflow{
       overflow: auto
 }
 .none-data{
   text-align: center;
    margin-top: 100px;
 }
 .none-data img{
   width: 30%
 }

</style>
<style>
 #dirManagement .error input{
  border-color:red
}
.dirManagement-pop-class{
  width: 35%;
  height: 200px;
  overflow-y: scroll;
}
#dirManagement .el-tree>.el-tree-node {
     min-width: 100%;
     display:inline-block !important;
 }
</style>



// WEBPACK FOOTER //
// src/pages/course/backend/dirManagement.vue